import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import RotateImageCommand from './rotateImageCommand';
import { createRotateImageButton } from './rotateImageUi';
import { addRotateImageEditing } from './rotateImageEditing';
import './imageRotation.css';

export default class RotateImage extends Plugin {
    init() {
        this.editor.commands.add('rotateImage', new RotateImageCommand(this.editor));
        createRotateImageButton(this.editor);
        addRotateImageEditing(this.editor);
    }
}
